import type { ReactElement } from "react";
import { YStack, XStack, Text, ListItem } from "tamagui";
import { colors } from "@styles/colors";
import {
  // TODO(account-hide): 偏好 / 安全與隱私 / 其他 群組暫時隱藏，待實作後恢復對應 icon import。
  // 詳見 docs/account-hidden-sections.md
  // RiNotification2Line,
  // RiSettings3Line,
  // RiShieldLine,
  // RiDoorLockLine,
  // RiFlashlightLine,
  // RiInformationLine,
  // RiFileList2Line,
  // RiStarLine,
  // RiErrorWarningLine,
  RiArrowDropRightLine,
} from "react-icons/ri";
// TODO(account-hide): RadiusBoxLabel 對應已隱藏的設定項目 icon，待實作後恢復。詳見 docs/account-hidden-sections.md
// import RadiusBoxLabel from "@components/layout/RadiusBoxLabel";
// TODO(account-hide): 全部群組目前皆隱藏，SETTING_DATA 為空陣列，故需顯式型別避免 implicit any。
type SettingItem = { id: string; label: string; desc: string; value: string; type: string; icon: ReactElement };
type SettingSection = { group: string; items: SettingItem[] };
const SETTING_DATA: SettingSection[] = [
  // TODO(account-hide): 偏好 群組暫時隱藏，待實作後恢復。詳見 docs/account-hidden-sections.md
  // {
  //   group: "偏好",
  //   items: [
  //     {
  //       id: "notifications",
  //       label: "通知設定",
  //       desc: "訂單、促銷、系統",
  //       value: "",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiNotification2Line color={colors.primary} />} />,
  //     },
  //     {
  //       id: "display",
  //       label: "顯示設定",
  //       desc: "",
  //       value: "跟隨系統",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiSettings3Line color={colors.primary} />} />,
  //     },
  //   ],
  // },
  // TODO(account-hide): 安全與隱私 群組暫時隱藏，待實作後恢復。詳見 docs/account-hidden-sections.md
  // {
  //   group: "安全與隱私",
  //   items: [
  //     {
  //       id: "account_security",
  //       label: "帳號安全",
  //       desc: "密碼、驗證、登入裝置",
  //       value: "",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiShieldLine color={colors.primary} />} />,
  //     },
  //     {
  //       id: "privacy_settings",
  //       label: "隱私設定",
  //       desc: "",
  //       value: "",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiDoorLockLine color={colors.primary} />} />,
  //     },
  //     {
  //       id: "biometrics",
  //       label: "生物辨識",
  //       desc: "Face ID 已啟用",
  //       value: "",
  //       type: "switch",
  //       icon: <RadiusBoxLabel icon={<RiFlashlightLine color={colors.primary} />} />,
  //     },
  //   ],
  // },
  // TODO(account-hide): 其他 群組暫時隱藏，待實作後恢復。詳見 docs/account-hidden-sections.md
  // {
  //   group: "其他",
  //   items: [
  //     {
  //       id: "faq",
  //       label: "常見問題",
  //       desc: "",
  //       value: "",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiErrorWarningLine color={colors.primary} />} />,
  //     },
  //     {
  //       id: "terms_privacy",
  //       label: "服務條款與隱私權",
  //       desc: "",
  //       value: "",
  //       type: "navigation",
  //       icon: <RadiusBoxLabel icon={<RiFileList2Line color={colors.primary} />} />,
  //     },
  //     {
  //       id: "rate_us",
  //       label: "為我們評分",
  //       desc: "",
  //       value: "",
  //       type: "action",
  //       icon: <RadiusBoxLabel icon={<RiStarLine color={colors.primary} />} />,
  //     },
  //     {
  //       id: "about",
  //       label: "關於",
  //       desc: "",
  //       value: "v4.7.2",
  //       type: "info",
  //       icon: <RadiusBoxLabel icon={<RiInformationLine color={colors.primary} />} />,
  //     },
  //   ],
  // },
];
export const OtherList = () => {
  // TODO(account-hide) 期間 SETTING_DATA 是空的：直接不渲染，否則會留下一個帶 mt="$5" 的空殼，
  // 在帳戶卡與付費紀錄之間多撐出 20px 的空白。
  if (SETTING_DATA.length === 0) return null;

  return (
    <YStack mt="$5" gap="$5">
      {SETTING_DATA.map((section) => (
        <YStack key={section.group} gap="$2.5">
          <XStack jc="space-between" ai="center" px="$1">
            <Text fontWeight="bold" fontSize={14}>
              {section.group}
            </Text>
          </XStack>
          <YStack ov="hidden" br="$4">
            {section.items.map((item) => (
              <ListItem
                h={65}
                key={item.id}
                style={{ background: "#fff" }}
                pressStyle={{ backgroundColor: "$gray3" }} // 加入點擊效果
                title={<Text fontWeight="bold">{item.label}</Text>}
                subTitle={item.desc ?? ""}
                icon={item.icon}
                iconAfter={
                  <XStack ai="center">
                    <Text fontSize={14} color={colors.gray} mx={2}>
                      {item.value}
                    </Text>
                    <RiArrowDropRightLine color={colors.grayDark} size={22} />
                  </XStack>
                }
                borderBottomWidth={1}
                borderBottomColor="$gray3"
              />
            ))}
          </YStack>
        </YStack>
      ))}
    </YStack>
  );
};
